import Button from 'components/Button'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

export function FaqItem ({ faq }) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const [isExpanded, setIsExpanded] = React.useState(false)

  return (
    <View
      bgc={isExpanded ? '#ffffff' : 'rgba(38, 50, 56, 0.3)'}
      jc
      style={{
        borderRadius: '10px',
        transition: '0.5s'
      }}
      mb='20px'
    >
      <Button
        isFullWidth
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          height: '80px',
          width: '100%',
          maxWidth: 'unset',
          padding: '0 20px',
          borderRadius: '10px'
        }}
      >
        <View
          row
          style={{ justifyContent: 'space-between' }}
          w='100%'
        >
          <Text
            c={isExpanded ? '#151D21' : '#ffffff'}
            fs='18px'
            mr='15px'
            style={{
              fontVariationSettings: '"wght" 760, "wdth" 40',
              textTransform: 'uppercase',
              textAlign: 'left'
            }}
          >
            {formatMessageIntlUtil(intl, faq.question)}
          </Text>
          <ArrowDownIcon
            fill={isExpanded ? '#151D21' : '#ffffff'}
            style={{
              width: '16px',
              height: '16px',
              transform: isExpanded ? 'rotate(180deg)' : 'unset',
              transition: '1s'
            }}
          />
        </View>
      </Button>
      {isExpanded && (
        <Text
          px='20px'
          c='#151D21'
          fs={isSmallScreen ? '14px' : '18px'}
          pb='20px'
        >
          {formatMessageIntlUtil(intl, faq.answer)}
        </Text>
      )}
    </View>
  )
}
